import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <path key='0' d='M48.4,15.5c0-1.5-1.2-2.6-2.7-2.6s-2.6,1.2-2.6,2.7l0.1,31.3c0,1.5,1.2,2.6,2.7,2.6c1.5,0,2.6-1.2,2.6-2.7L48.4,15.5z' />,
    <path
      key='1'
      d='M35.9,53.7H23.1c-2.4,0-4.2-1.9-4.2-4.2V14.6c0-2.4,1.9-4.2,4.2-4.2h12.9c2.4,0,4.2,1.9,4.2,4.2v34.9
	C40.2,51.8,38.3,53.7,35.9,53.7z'
    />,
  ],
  'TransportCover'
);

const TransportCoverIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportCoverIcon);
